module.exports = __webpack_public_path__ + "img/finance_kas_bank.e5fb38dd.svg";